const recaptchaKey = process.env.NEXT_PUBLIC_RECAPTCHA_KEY || 'token';
export default recaptchaKey;
